import React, { useEffect, useState } from "react";
import { FILTER_VALUE_FINALIZADOS } from "../../../const/filtersValue/filterValue";
import { getChatsFinish } from "../../../helpers/fetch/getChatsFinish";

const BtnGetMoreChats = ({ chats, setChats, searchChatFinish }) => {

    const [loading, setLoading] = useState(false); //Estado para manejar el estado de carga.
    const [showButton, setShowButton] = useState(true);
    
    const onGetChat = async () => { //Función cuándo se presiona el botón para traer más chats.
        console.log("los chats que llegaron inicialmente", chats)
        setLoading(true); // Mostrar "cargando..." en el botón.
        console.log("ahora estos son los chats según la búsqueda", searchChatFinish)
        //Guardar la Posición del último elemento del array de chats finalizados.
        let lastChatPosition = chats[chats.length -1].Position;
        console.log("posición antes de la petición", lastChatPosition)

        //Invoca a la función para traer los chats.
        const moreChats = await getChatsFinish({filter: FILTER_VALUE_FINALIZADOS, idLastChatPosition: lastChatPosition, chatEndedSearched: searchChatFinish}); 

        if (moreChats.length > 0) { //Si la repuesta devuelve más chats.
            setLoading(false); //Dejar de mostrar el "cargando...".
            setChats(preChats => preChats.concat(moreChats)); //Concatenar los chats entrantes a la lista existente.
            setLoading(false);
        } else setShowButton(false) //Si ya no hay chats en la respuesta, quiere decir que ya no hay chats finalizados por mostrar.
    };

    const onShowButton = () => { //Función para mostrar el botón de traer más chats finalizados.
        if (chats.length > 5) {setShowButton(true); setLoading(false);} //Si hay más de 5 chats en la lista, permitir que se muestre el botón.
        else setShowButton(false); // si no hay más de 5 chats en la lista, ocultar el botón.
    }

    useEffect(() => onShowButton(), [chats]); // Se ejecuta para mostrar el botón de cargar más chats finalizados.

    return (
        <>
        { showButton &&
        <div className="container-btn__getMoreChats">
            <button className="btn-getMoreChats" onClick={onGetChat}>
               { loading ? "Cargando..." : "Cargar más Chats"}

            </button>
        </div>}
        </>

    )
};

export default BtnGetMoreChats;